import { Type, type Static } from 'typebox';

/* The one error shape every endpoint returns. Clients branch on `code`, never on `message`. */
export const Problem = Type.Object(
  {
    code: Type.String({ description: 'Stable machine-readable error code, e.g. BOOKING_CONFLICT' }),
    message: Type.String({ description: 'Human-readable summary in English; not for display logic' }),
    details: Type.Optional(Type.Record(Type.String(), Type.Unknown())),
  },
  { additionalProperties: false },
);
export type Problem = Static<typeof Problem>;
